export const rightPanelActions = (state, dispatch, props) => {
  function updateRightPanel(rightPanelData) {
    dispatch({ type: "RIGHTPANEL_UPDATE", payload: rightPanelData });
  }

  return {
    updateRightPanel,
  };
};
